import PageHero from "@/components/feature/PageHero";
import CtaSection from "@/components/feature/CtaSection";
import Reveal from "@/components/base/Reveal";
import AnimatedStatValue from "@/components/base/AnimatedStatValue";
import { aboutValues, aboutMilestones, heroStats } from "@/mocks/public";

export default function AboutPage() {
  return (
    <div className="flex flex-col">
      <PageHero
        eyebrow="À propos"
        current="À propos"
        title="Nous simplifions la gestion immobilière au Burkina Faso"
        description="ImmoBF est né d'un constat simple : la gestion des immeubles et des locations mérite des outils adaptés à la réalité locale."
      />

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal variant="left">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">Notre mission</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              Nous voulons permettre à chaque propriétaire et à chaque agence immobilière de gérer son patrimoine avec la
              même rigueur qu'une grande structure, sans complexité technique. Immeubles, biens, locataires, contrats,
              loyers, paiements, impayés, entretiens, dépenses et documents : tout est centralisé, en FCFA, dans une
              interface pensée pour le Burkina Faso.
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              Notre priorité : des outils simples, fiables et compréhensibles, utilisables sur ordinateur comme sur
              téléphone, dans les grandes villes comme en province.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {heroStats.map((stat) => (
                <div
                  key={stat.label}
                  className="stat-block rounded-lg border border-background-200 bg-background-100/60 p-4"
                >
                  <AnimatedStatValue value={stat.value} className="text-xl font-heading font-semibold text-foreground-950" />
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {aboutValues.map((value, index) => (
              <Reveal key={value.title} delay={index * 80} className="h-full">
                <div className="card-lift h-full rounded-lg border border-background-200 bg-background-100/60 p-5 hover:border-primary-300 hover:bg-background-50">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-50 text-secondary-600">
                    <i className={`${value.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <h3 className="mt-3 text-base font-heading font-semibold text-foreground-950">{value.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600">{value.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="container-page">
          <Reveal>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-center text-foreground-950">
              Notre parcours
            </h2>
          </Reveal>
          <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-4">
            {aboutMilestones.map((item, index) => (
              <Reveal key={item.year} delay={index * 90} className="h-full">
                <div className="card-lift h-full rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300">
                  <span className="font-heading text-2xl font-semibold text-primary-500">{item.year}</span>
                  <h3 className="mt-2 text-base font-heading font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600">{item.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Rejoignez les propriétaires et agences qui s'organisent."
        description="Créez votre espace gratuitement et découvrez la plateforme à votre rythme."
      />
    </div>
  );
}